import { PublicClientApplication } from '@azure/msal-browser';

var msalInstance: PublicClientApplication | undefined;

export const getMsalInstance = () => {
  return msalInstance;
};

export const setMsalInstance = (
  instance: PublicClientApplication | undefined
) => {
  msalInstance = instance;
};
